import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "Myanmar3, Roboto, sans-serif",
  },
  zIndex: {
    snackbar: 1900,
  },
  components: {
    MuiGrid: {
      styleOverrides: {
        root: {
          "& .highlight": {
            background: "#00aeef",
            color: "#fff",
          },
          "& .detailBox:hover": {
            border: "1px solid #00aeef",
          },
          "& .fullCircle,.t-flight-arrivalPoint": {
            backgroundColor: "#00aeef",
            border: "1px solid #00aeef",
          },
          "& .circle,.departurePoint": {
            border: "1px solid #00aeef",
          },
          "& .covidInfoContainer": {
            border: "1px solid #00aeef",
          },
          "& .CalendarDay__selected,.selectedMultiDateBox": {
            backgroundColor: "#00aeef !important",
          },
          "& .DateInput_fangStroke": {
            fill: "#00aeef !important",
            stroke: "#00aeef !important",
          },
          "& .CalendarDay:hover,.popupSearch,.domesticInternationalTabsBtnActive":
            {
              backgroundColor: "#00aeef !important",
            },
          "& .airportSearchIcon,.nextDate:before,.previousDate:before": {
            color: "#00aeef !important",
          },
          "& .airportNames:hover": {
            color: "#00aeef !important",
            cursor: "pointer",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            background: "#00aeef",
            color: "#fff",
          },
          "&.btnEditSearch": {
            color: "#fc9d00",
          },
          "&.btnEditSearch:hover": {
            color: "#fff",
            backgroundColor: "#fc9d00 !important",
          },
          "&.choosePackBtn:hover": {
            backgroundColor: "#00aeef",
            color: "#fff",
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#00aeef",
      bg: "#00aeef",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fc9d00",
      contrastText: "#fff",
    },
    thirdColor: {
      main: "#e6eaed",
      contrastText: "#231f20",
    },
  },
});
export const kbzTheme = createTheme({
  zIndex: {
    snackbar: 1900,
  },
  components: {
    MuiGrid: {
      styleOverrides: {
        root: {
          "& .client-theme-color": {
            color: "#0b55a8",
          },
          "& .client-theme-background": {
            background: "#0b55a8",
          },
          "& .t-client-theme-background": {
            background: "#0b55a8!important",
          },
          "& .t-client-triangleup-borderBottom": {
            borderBottom: `15px solid #0b55a8`,
          },
          "& .detailBox:hover": {
            border: "1px solid #0b55a8",
          },
          "& .fullCircle,.t-flight-arrivalPoint": {
            backgroundColor: "#0b55a8",
            border: "1px solid #0b55a8",
          },
          "& .circle,.t-flight-departurePoint": {
            border: "1px solid #0b55a8",
          },
          "& .highlight": {
            background: "#0b55a8",
            color: "#fff",
          },

          "& .fullCircle,.arrivalPoint": {
            backgroundColor: "#0b55a8",
            border: "1px solid #0b55a8",
          },
          "& .circle,.departurePoint": {
            border: "1px solid #0b55a8",
          },
          "& .covidInfoContainer": {
            border: "1px solid #0b55a8",
          },
          "& .CalendarDay__selected,.selectedMultiDateBox": {
            backgroundColor: "#0b55a8 !important",
          },
          "& .DateInput_fangStroke": {
            fill: "#0b55a8 !important",
            stroke: "#0b55a8 !important",
          },
          "& .CalendarDay:hover,.popupSearch,.domesticInternationalTabsBtnActive":
            {
              backgroundColor: "#0b55a8 !important",
            },
          "& .airportSearchIcon,.nextDate:before,.previousDate:before": {
            color: "#0b55a8 !important",
          },
          "& .airportNames:hover": {
            color: "#0b55a8 !important",
            cursor: "pointer",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            background: "#0b55a8",
            color: "#fff",
          },
          "&.btnEditSearch": {
            color: "#fc9d00",
          },
          "&.btnEditSearch:hover": {
            color: "#fff",
            backgroundColor: "#fc9d00 !important",
          },
          "&.choosePackBtn:hover": {
            backgroundColor: "#00aeef",
            color: "#fff",
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#0b55a8",
      bg: "#0b55a8",
      contrastText: "#fff",
    },
    secondary: {
      main: "#052a54",
      contrastText: "#fff",
    },
    thirdColor: {
      main: "#052a54",
      contrastText: "#231f20",
    },
  },
});
